import api from '../../../api/general'

export const loadUser = ({ commit }) => {
    api.getUser().then(res => {
        commit('SET_USER_ID', res.data.id)
        commit('SET_USER_NAME', res.data.full_name)
        commit('SET_COMPANY_ID', res.data.company_id)
        commit('SET_COMPANY_NAME', res.data.company_name)
        commit('SET_PRIMARY_COLOR', res.data.primary_color)
        commit('SET_NOTIFICATIONS_PREFERENCES', res.data.notifications)
        commit('SET_IS_POWER_USER', !!res.data.is_power_user)
        commit('SET_USER_TIMEZONE', res.data.timezone)
    }).catch(e => {
        if (e.response.status === 401) {
            api.logUser()
                .then(res => {
                    if (res.data === 'success') {
                        location.reload()
                    } else {
                        document.location.href = 'https://' + window.location.hostname + '/logout'
                    }
                })
        }
    })
}

export const loadUserPermissions = ({ commit }) => {
    api.getUserPermissions().then(res => {
        commit('SET_USER_PERMISSIONS', res.data)
    })
}

export const loadUserCompanyTierInfo = ({ commit }) => {
    commit('SET_TIER_LOADING', true)

    api.getTierInfo().then(res => {
        commit('SET_COMPANY_TIER', {
            pois: res.data.limits.pois,
            brands: res.data.limits.brands,
            categories: res.data.limits.categories
        })

        commit('SET_COMPANY_TIER_STATUS', {
            pois: res.data.data.pois,
            brands: res.data.data.brands,
            categories: res.data.data.categories
        })

        commit('SET_TIER_LOADING', false)
    })
}